import React from 'react'
import $ from 'jquery';
import Page from '../Page'
import { API_GET_GAME_QUIZ} from '../Util'
import {Input, Button, Modal } from 'react-materialize'
import { notify } from "react-notify-toast";

import './multipleChoice.css'

class MultipleChoiceGame extends Page {
	constructor(props) {
	    super(props);
      const first_states = this.beforeRender(props)
	    this.state = {
         ...first_states,
         // isTrue: null,
         // notifMessage:''
      };
	}

   beforeRender(){
      let questionData = this.props.question
      questionData[0].isMatched = null
      return {
        answer: this.props.answer,
        question: questionData,
        uuid: this.props.uuid
      }
    }

	componentDidMount() {
	    this.handleLoadData();
	}

	handleLoadData = () => {
      this.setState({ answer: this.props.answer, question : this.props.question});
	}

	handleConfirmSubmit = (e) => {
		e.preventDefault();
		$("#submit-btn").trigger("click");
	}

	handleSubmitQuiz = (e) => {
      e.preventDefault();
      if(this.state.question[0].answer_id === this.state.question[0].isMatched){
         $.post(API_GET_GAME_QUIZ + this.state.uuid).then(response => {
            // this.setState({isTrue: true, notifMessage:'Selamat! Jawaban kamu tepat'})
            // this.props.nextChapter()
            // notify.show('Selamat! Jawaban kamu tepat', "success");
            this.props.updateData(true)
            $("#submit-btn").trigger("click");
         })
      }else{
         $.post(API_GET_GAME_QUIZ + this.state.uuid).then(response => {
            // this.setState({isTrue: false, notifMessage:'Jawaban kamu salah! Silakan tingkatkan lagi proses belajar kamu yah' })
            this.props.updateData(false)
            let answer = this.state.answer
            let question = this.state.question
            let answerIndex = answer.findIndex(item => item.id === +question[0].isMatched)
            answer[answerIndex].isTrue = false
            this.setState({answer})
            // this.props.nextChapter()
            // notify.show('Jawaban kamu salah! Silakan tingkatkan lagi proses belajar kamu yah', "warning");
            $("#submit-btn").trigger("click");
         })
      }
	}

   handleNotifQuiz = () => {
      this.props.nextChapter()
   }

	handleNextQuestion = (e) => {
      this.handleConfirmSubmit(e);
	}

	handlePreviousQuestion = () => {
	    this.setState({question : this.state.data.questions[this.state.question.order-1]});
	    super.scrollToTop();
	}

	handleSelectAnswer = (e) => {
		var question = this.state.question;
		question[0].isMatched = +e.target.value;
      question[0].isAnswered = 1
		this.setState({question});
	}

  	render() {
  		var {question, answer, isTrue} = this.state;

  		return (
  			<div className="bg-white fullheight">            
	  			<form onSubmit={(e)=>this.handleSubmitQuiz(e)} className="pad-ml">
		  			<div className="container mt-m mb-m">
		  				{/* <h5 className="font-orange">Pertanyaan {question.order + 1}</h5> */}
		  				<h5><p>{question[0].question}</p></h5>

		  				<div className="answers">
		  				{
                     answer.map((item, i) =>
                        {
                           return(
                              typeof item.isTrue !== 'undefined' && !item.isTrue ? (
                                 <p className="disable-answer">
                                    <Input required onClick={this.handleSelectAnswer} name='answer' type='radio' value={item.id} label={item.name} checked={question[0].isMatched == item.id} disabled/>
                                 </p>
                              ) : (
                                 <p className=''>
                                    <Input required onClick={this.handleSelectAnswer} name='answer' type='radio' value={item.id} label={item.name} checked={question[0].isMatched == item.id} />
                                 </p>
                              )
                           )
                        }
                     )
                  }
                  <div>&nbsp;</div>
                  {
                     this.state.isTrue === true ? (
                        <h4 style={{color:'#134b95'}}>Benar!</h4>
                     ): this.state.isTrue === false &&(
                        <h4 style={{color:'red'}}>Salah!</h4>
                     )
                  }
                  </div>

                  <div className="pt-xl">
                     {
                        question[0].isAnswered != 0 && (
                           <div className="container">
                              <Button className="right">SUBMIT</Button>
                           </div>
                        )
                     }
                  </div>
                  <br/><br/>
		  			</div>
		  		</form>
              <Modal 
               trigger={
                  <Button id="submit-btn" className="right hide">SUBMIT</Button>
               }
               >
                  <h3 style={{textAlign:'center', color:'black'}}>Jawaban Kamu {this.props.isTrue ? 'Benar' : 'Salah'}!</h3>
                  <p style={{textAlign:'center'}}>{this.props.notifMessage}</p>
                  <div className="mt-m" style={{display:'flex', justifyContent:'center'}}>
                  <a onClick={this.handleNotifQuiz.bind(this)} className="btn">OK</a>
                  </div>
               </Modal>
  			</div>
  		)
	}
}
export default MultipleChoiceGame



// WEBPACK FOOTER //
// ./src/components/GameQuiz/MultipleChoiceQuiz.js